import { createElement, lazy, Suspense } from 'react';

const LazyDocumentForm = lazy(() => import('../arito/form/document-form'));

export const DocumentForm = (props: any) =>
  createElement(Suspense, { fallback: null }, createElement(LazyDocumentForm, props));

export { DvtFormField } from '../arito/form/dvt-field/dvt-form-field';
export { AritoIcon } from '../arito/icon';
export { default as AritoConfirmModal } from '../arito/confirm-modal';
export { default as AritoNotifyModal } from '../arito/notify-modal';
export { default as AritoColoredDot } from '../arito/colored-dot';
export { default as RadixHoverDropdown } from '../arito/hover-dropdown/radix-hover-dropdown';
export * from '../arito/form/search-fields';
export { default as ColorSelect } from '../arito/form/color-select';
export { default as MultiSelect } from '../arito/form/multi-select';
export { AritoSelect } from '../arito/form/custom-select';
export { default as FormDateRangeDropdown } from '../arito/form/form-date-range-dropdown';
export { default as AritoFormDateRangeDropdown } from '../arito/form/form-date-range-dropdown';
export * from '../arito/form/document-number/util';
export { ReportTemplateDropdown } from '../arito/form/report-template-dropdown';
export { EditPrintTemplateDialog } from '../arito/edit-print-template';
export type { SearchColumnDef } from '../arito/search-table';
export type { FilterableColumnConfig } from '../arito/data-tables/types';
export { default as SidebarButton } from '../arito/sidebar-button';
export { AritoSplitPane } from '../arito/split-pane';
export { AritoLocalTabs } from '../arito/local-tabs';
export { ExternalLink } from '../arito/external-link';
export { default as HeaderBar } from '../arito/form/header-bar';
export { default as AritoCheckboxCellRenderer } from '../arito/cell-renderers/arito-checkbox-cell-renderer';
export { FormModeProvider, useFormMode } from '../arito/cell-renderers/arito-checkbox-cell-renderer';
export type { InputTableCellParams, InputTableProps } from '../arito/custom-input-table/types';
export { useColumnSearch } from '../arito/custom-input-table/hooks/useColumnSearch';
export { useContextMenu } from '../arito/custom-input-table/hooks/useContextMenu';
export { useContextMenuOptions } from '../arito/custom-input-table/hooks/useContextMenuOptions';
export { useSort } from '../arito/custom-input-table/hooks/useSort';
export type { PasteConfigMap, PasteResolver, TableRowBase } from '../arito/custom-input-table/hooks/useTableRows';
export * from '../arito/custom-input-table/utils';
export { AritoInputTable } from '../arito/input-table';
export { InputTable as AritoCustomInputTable } from '../arito/custom-input-table';
export type { AritoInputTableProps } from '../arito/input-table/types';
export { default as AritoModal } from '../arito/modal';
export { default as BulkDeleteDialog } from '../arito/bulk-delete-dialog-v4';
export { default as BulkDeleteDialogV2 } from '../arito/bulk-delete-dialog-v2';
export { default as BulkDeleteDialogV4 } from '../arito/bulk-delete-dialog-v4';
export { default as TanstackBulkDeleteDialog } from '../arito/bulk-delete-dialog-v4';
export { default as TanstackBulkDeleteDialogV2 } from '../arito/bulk-delete-dialog-v4';
export { RadioButton } from '../arito/form/radio-button';
export { default as GetDocuments } from '../arito/form/get-documents';
